import { Divider, Typography } from "@mui/material";
import {
  NoteEditWrapper,
  RiskSelectController,
  SubSectionTitle,
  useSpContext,
  WorkloadAssessmentEdit,
} from "components/summary/success-plan";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import { UseFormReturn } from "react-hook-form";
import styles from "./SuccessPlanWorkflow.module.scss";

type WorkloadAssessmentStepProps = {
  spState: SuccessPlanState;
  form: UseFormReturn<any>;
};

const WorkloadAssessmentStep = ({ spState, form }: WorkloadAssessmentStepProps) => {
  const { spData } = spState;
  const histories = spData.histories || [];
  const { wemSuite, wemVideoDevice, wemContactCenter } = spData;

  const { riskItems } = useSpContext();
  const { control, setValue } = form;

  const deviceNoteHistories = histories.filter(
    (history: any) => history.fieldName === "deviceRiskNote"
  );
  const meetingNoteHistories = histories.filter(
    (history: any) => history.fieldName === "meetingRiskNote"
  );
  const callingNoteHistories = histories.filter(
    (history: any) => history.fieldName === "callingRiskNote"
  );

  const isDeviceRequired = wemVideoDevice !== null;
  const isMeetingRequired = wemSuite !== null;

  return (
    <div className={styles["step-wrapper"]}>
      <div className={styles["grid-two-lane"]}>
        {/* device workload */}
        <div className={styles["grid-column-span-2"]}>
          <SubSectionTitle title="Devices Workload" />
        </div>
        <div className={styles["form-field-wrapper"]}>
          <Typography className={styles["form-field-label"]}>
            Devices Workload Risk Assessment:
          </Typography>
          {isDeviceRequired && <Typography className={styles["form-field-star"]}>*</Typography>}
        </div>
        <RiskSelectController
          control={control}
          name="deviceRisk"
          riskItems={riskItems}
          required={isDeviceRequired}
        />
        <div className={styles["grid-column-span-2"]}>
          <NoteEditWrapper
            label="Devices Workload Assessment Notes:"
            required={isDeviceRequired}
            histories={deviceNoteHistories}
            name="deviceRiskNote"
            control={control}
            setValue={setValue}
          />
        </div>
        <div className={styles["grid-column-span-2"]}>
          <Divider />
        </div>

        {/* meeting workload */}
        <div className={styles["grid-column-span-2"]}>
          <SubSectionTitle title="Meetings Workload" />
        </div>
        <div className={styles["form-field-wrapper"]}>
          <Typography className={styles["form-field-label"]}>
            Meeting Workload Risk Assessment:
          </Typography>
          {isMeetingRequired && <Typography className={styles["form-field-star"]}>*</Typography>}
        </div>
        <RiskSelectController
          control={control}
          name="meetingRisk"
          riskItems={riskItems}
          required={isMeetingRequired}
        />
        <div className={styles["grid-column-span-2"]}>
          <NoteEditWrapper
            label="Meeting Workload Assessment Notes:"
            required={isMeetingRequired}
            histories={meetingNoteHistories}
            name="meetingRiskNote"
            control={control}
            setValue={setValue}
          />
        </div>
        <div className={styles["grid-column-span-2"]}>
          <Divider />
        </div>

        {/* calling workload */}
        <div className={styles["grid-column-span-2"]}>
          <SubSectionTitle title="Calling Workload" />
        </div>
        <div className={styles["form-field-wrapper"]}>
          <Typography className={styles["form-field-label"]}>
            Calling Workload Risk Assessment:
          </Typography>
          {isMeetingRequired && <Typography className={styles["form-field-star"]}>*</Typography>}
        </div>
        <RiskSelectController
          control={control}
          name="callingRisk"
          riskItems={riskItems}
          required={isMeetingRequired}
        />
        <div className={styles["grid-column-span-2"]}>
          <NoteEditWrapper
            label="Calling Workload Assessment Notes:"
            required={isMeetingRequired}
            histories={callingNoteHistories}
            name="callingRiskNote"
            control={control}
            setValue={setValue}
          />
        </div>
        <div className={styles["grid-column-span-2"]}>
          <Divider />
        </div>

        {/* Webex Contact Center workload */}
        <WorkloadAssessmentEdit
          title="Webex Contact Center Workload Assessment"
          dropDownLbl="Contact Center Workload Risk Assessment:"
          dropDownField="contactCenterRisk"
          noteLbl="Contact Center Workload Assessment Notes:"
          noteField="contactCenterRiskNote"
          required={wemContactCenter !== null}
          form={form}
          histories={histories}
          historyField="contactCenterRiskNote"
          addDivider={false}
        />
      </div>
    </div>
  );
};

export default WorkloadAssessmentStep;
